"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeParse = safeParse;
exports.safeParseBool = safeParseBool;
function safeParse(maybeJsonString) {
    var result;
    try {
        result = JSON.parse(maybeJsonString);
    }
    catch (e) {
        console.error("Error parsing JSON " + maybeJsonString + ": ", e);
        result = {};
    }
    return result;
}
function safeParseBool(maybeJsonString) {
    var result;
    try {
        result = JSON.parse(maybeJsonString);
    }
    catch (e) {
        console.error("Error parsing JSON: ", e);
    }
    return result;
}
